<template>
    <section class="faq_section" :style="'min-height:'+$minHeight+';'">
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <div class="container">
            <div class="faq-title">
                <div class="faq-title-content">
                    {{ data.pageCMS.top_title }}
                </div>
            </div>
            <div class="faq_accordion_section">
                <div class="row justify-content-center">
                    <div class="col-12 mb-5">
                        <div class="nav nav-pills  nav-justified shadow-sm rounded-sm" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                            <a v-for="(row, index) in data.data" :key="index" class="nav-link" :class="[(isActive == index) ? 'active' : '']" :id="'v-pills-GettingEstimate-tab'+index" data-toggle="pill" :href="'#v-pills-GettingEstimate'+index" role="tab"
                                aria-controls="v-pills-GettingEstimate" aria-selected="true" @click="activeTab(index)"> {{ row.name }}
                            </a>
                        </div>
                    </div>
                    <div class="col-12 col-lg-9">
                        <div class="tab-content" id="v-pills-tabContent">
                            <div class="tab-pane fade show" :class="[(isActive == index) ? 'active' : '']" :id="'#v-pills-GettingEstimate'+index" v-for="(row, index) in data.data" :key="index" role="tabpanel" aria-labelledby="v-pills-GettingEstimate-tab">
                                <div id="main">
                                    <div class="accordion" id="faq">
                                        <div class="card shadow" v-for="(row, index) in row.subCategory" :key="index">
                                            <div class="card-header" :id="'faqhead'+row.id">
                                                <a @click="contentShow(row.id)" href="#" class="btn btn-header-link" data-toggle="collapse" :data-target="'#faq'+row.id" aria-expanded="true" :aria-controls="'faq'+row.id">
                                                    <img src="../../assets/images/faq.svg" class="mr-2"> {{ row.title }}
                                                </a>
                                            </div>
                                            <div :id="'faq'+row.id" class="collapse" :class="[(isShow == row.id) ? 'show' : '']" :aria-labelledby="'faqhead'+row.id" data-parent="#faq">
                                                <div class="card-body" v-html="row.detail">
                                        
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
// import $ from 'jquery'
import Loading from "vue-loading-overlay";

export default {
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            data: [],
            imagePath: this.$api + "upload/faq_cms/",
            isActive: 0,
            isShow: 0,
        }
    },
    mounted(){
        var pageHeight=window.innerHeight-390;
        this.$minHeight=pageHeight+"px";
    },
    created() {
        document.title = "Geek Buy Back - FAQ";
        this.getFAQ();

        let jqueryScript = document.createElement('script')
        jqueryScript.setAttribute('src', '/jquery.min.js')
        document.head.appendChild(jqueryScript)

        let bootstrapScript = document.createElement('script')
        bootstrapScript.setAttribute('src', '/bootstrap.bundle.min.js')
        document.head.appendChild(bootstrapScript)
    },
    methods: {
        getFAQ: function() {
            this.isLoading = true;
            var config = {
                method: "GET",
                url: this.$api + this.$config.FAQ.getFAQURL
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    this.data = response.data.data;
                    console.log(this.data);
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        },
        activeTab: function(index) {
            this.isActive = index;
        },
        contentShow: function(index) {
            this.isShow = index;
        }
    }
}
</script>
